
export interface IUserAddProps {
  firstName: string
  lastName: string
  platformFee: number,
  email: string
  role: string
  companyName: string
  companyAddress: string
  csbClientId: string
}

export interface IUserEditProps {
  firstName: string
  lastName: string
  platformFeeRate: number
  email: string
  companyName: string
  companyAddress: string
}

export interface IUserChangeLocal {
  locale: string;
}
export enum ManagerStatus {
  moderation = 'In moderation',
  hired = 'Hired',

  // Only in front
  canceled = 'Canceled',
}

export type TUserAttributes = { type: string; value: string }[];

interface Pageable {
  page: number;
  size: number;
  sort: string[];
}

interface AccountBalance {
  fiat: number;
  crypto: {
    additionalProp1: number;
    additionalProp2: number;
    additionalProp3: number;
  };
}

export interface IUser {
  id: string;
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  role: string;
  hasPassword: boolean;
  kycStatus: string;
  emailNotify: boolean;
  mfaConfirmed: boolean;
  avatarUrl: string;
  accountBalance: AccountBalance;
  status: string;
  platformFee: number
  companyName: string
  companyAddress: string
  csbClientId: string
}

interface Sort {
  sorted: boolean;
  unsorted: boolean;
  empty: boolean;
}

export interface IUserList {
  totalElements: number;
  totalPages: number;
  sort: Sort;
  first: boolean;
  last: boolean;
  number: number;
  pageable: Pageable;
  numberOfElements: number;
  size: number;
  empty: boolean;
  content: IUser[];
}

export type TUserAttr = {
  [key: string]: string[];
};

export enum UserRoles {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_MANAGER = 'ROLE_MANAGER',
  ROLE_USER = 'ROLE_USER',
  ROLE_VENDOR = 'ROLE_VENDOR',
  ROLE_BUYER = 'ROLE_BUYER',
  ROLE_VENDOR_STAFF = 'ROLE_VENDOR_STAFF',
  ROLE_CONTENT_MANAGER = 'ROLE_CONTENT_MANAGER',
}

export type UserRoleType =
  | 'ADMIN'
  | 'USER';

export enum LoginType {
  email = 'email',
  phone = 'phone',
  login = 'login',
}

export type TUserCountry = {
  code: string;
  en_name: string;
  id: number;
  mask: string;
  ru_name: string;
};

export interface ILogin {
  email: string
  password: string
  applicationDeviceId: string
  devicePlatform: string
}

export interface ICheckMfa {
  applicationDeviceId: string
  code: string
}

export interface IRefreshToken {
  type: string
  accessToken: string
  refreshToken: string
}